import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, memo, Suspense } from "react";
import styles from './HomePage.module.scss';
import { EmojiStyle } from 'emoji-picker-react';
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { setSelectedEmoji } from "../../store/slices/appSlice";
import classNames from "classnames";
import Preloader from '../../assets/preloader.svg';
const EmojiPickerLazy = lazy(() => import('emoji-picker-react'));
const EmojiComponent = ({ height }) => {
    console.log('render emoji');
    const isOpen = useAppSelector(state => state.app.emojiIsOpen);
    const dispatch = useAppDispatch();
    const selectEmoji = (e) => {
        dispatch(setSelectedEmoji(e.emoji));
    };
    return (_jsx("div", { className: classNames(styles.emojiControl__component, { [styles.emojiControl__component_show]: isOpen }), children: isOpen &&
            _jsx(Suspense, { fallback: _jsx(Preloader, {}), children: _jsx(EmojiPickerLazy, { className: styles.emojiControl_wrapper, autoFocusSearch: false, open: isOpen, lazyLoadEmojis: true, skinTonesDisabled: true, emojiStyle: EmojiStyle.GOOGLE, onEmojiClick: selectEmoji, height: height, width: 250, previewConfig: { showPreview: false } }) }) }));
};
export default memo(EmojiComponent);
